import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getFinansistCatalogContragents } from "../../../../api/timesheetApi";
import { normalizeFinansistCatalogContragents } from "../../../../utils/finansistContragentMapping";
import { selectStyles } from "../../../../utils/selectStyles";

const FinansistContragentSelect = ({ value, onChange, disabled = false }) => {
  const [catalogLoading, setCatalogLoading] = useState(true);
  const [catalogError, setCatalogError] = useState("");
  const [contragents, setContragents] = useState([]);

  useEffect(() => {
    let cancelled = false;

    const loadCatalog = async () => {
      setCatalogLoading(true);
      setCatalogError("");
      try {
        const raw = await getFinansistCatalogContragents({
          allPages: true,
          maxPages: 100,
        });
        if (cancelled) return;
        setContragents(normalizeFinansistCatalogContragents(raw));
      } catch (err) {
        if (!cancelled) {
          setCatalogError(
            err.message || "Не удалось загрузить контрагентов Finansist",
          );
        }
      } finally {
        if (!cancelled) {
          setCatalogLoading(false);
        }
      }
    };

    loadCatalog();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const selected = value?.finansistContragent;
    if (!selected?.value || !contragents.length) return;

    const fromCatalog = contragents.find(
      (c) => Number(c.value) === Number(selected.value),
    );
    if (fromCatalog && fromCatalog.label !== selected.label) {
      onChange({ finansistContragent: fromCatalog });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- только при появлении каталога
  }, [contragents]);

  return (
    <li className="registration__inputs-container">
      <label className="registration__label">Контрагент Finansist</label>
      <Select
        options={contragents}
        value={value.finansistContragent}
        onChange={(opt) => onChange({ finansistContragent: opt })}
        styles={selectStyles}
        placeholder={
          catalogLoading ? "Загрузка..." : "Выберите контрагента Finansist"
        }
        isLoading={catalogLoading}
        isClearable
        isDisabled={disabled || catalogLoading || !!catalogError}
        noOptionsMessage={() => "Контрагенты не найдены"}
        menuPortalTarget={document.body}
        menuPosition="fixed"
      />
      {catalogError && (
        <span className="error-message">{catalogError}</span>
      )}
    </li>
  );
};

export default FinansistContragentSelect;
